import academy from "../assets/images/academy.png";
import experienced from "../assets/images/experienced.png";
import internship from "../assets/images/internship.png";

export const careerData = [
  {
    heading: "PAC ACADEMY",
    text: [
      "The PAC Academy is an annual Graduate Trainee Programme that comprises  of classroom trainings and rotations across the various Strategic Business Units (SBUs) within the PAC Group. The Academy provides a platform for successful candidates to be trained and mentored by experienced professionals along their areas of interests.",
    ],
    eligibility: [
      "Graduates from Nigerian & Foreign Universities",
      "Bachelors degree in any discipline",
      "Minimum of Second-Class Lower Division (2.2)",
      "Completion of NYSC as at the time of application",
      "Maximum age of 27 years",
    ],
    image: academy,
  },
  {
    heading: "Experienced Hire",
    text: [
      "We appreciate the new ideas and perspective of experienced hires which we find valuable to us- to join our existing team of competent staff. Whatever industry experiences you have as long as the experiences translates to our core businesses, we would be happy to have you join our team and you can expect to make a difference from day one.",
      " You will find your experience both rewarding and challenging, so if you’re looking for a place to develop your career, this is a journey you’ll want partake in.",
    ],
    eligibility: ["A minimum of three (3) years relevant work experience."],
    image: experienced,
  },
  {
    heading: "PAC Internship",
    text: [
      "Our Internship Programme offers students and recent graduates from diverse academic backgrounds the opportunity to gain hands-on experience with PAC Holdings through internship opportunities.",

      "Interns at PAC Holdings get experiential learning opportunities in the financial sector and a meaningful internship experience that will support their academic, professional, and personal development.",
    ],
    eligibility: false,
    image: internship,
  },
];
